/* src/app/pages/auth/mfa/mfa.component.scss */
.error {
  font-size: 12px;
}
/*# sourceMappingURL=mfa.component.css.map */
